export default (el) => {
    el.addEventListener('click', (event) => {
        document.querySelector('.myab__box').classList.add('-loading');
    });
};
